export function round(num: number, pointValue?: number): string {
  num = !num ? 0 : num;
  if (!pointValue) {
    return num.toString();
  } else {
    return num.toFixed(pointValue);
  }
}
